/*
 * Filmy w sekcjach „media-with-text" i „offer-hub" stoją pod zgięciem, a mimo
 * to pobierały się przy każdym wejściu na stronę — razem ponad 6 MB. Liquid
 * oddaje je teraz z adresem w data-src i bez autoplay, a ten skrypt wczytuje je
 * dopiero, gdy wjeżdżają w pole widzenia.
 *
 * Do tego czasu widoczny jest plakat, który Shopify generuje razem ze
 * znacznikiem wideo, więc kafelek nigdy nie jest pusty.
 */
(function () {
  var videos = document.querySelectorAll('video[data-deferred]');
  if (!videos.length) return;

  function start(video) {
    if (video.dataset.deferredDone) return;
    video.dataset.deferredDone = '1';

    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
      sources[i].removeAttribute('data-src');
    }

    video.load();
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  // Bez IntersectionObserver wczytujemy od razu — lepiej stracić oszczędność
  // niż pokazać kafelek, który nigdy nie ruszy.
  if (!('IntersectionObserver' in window)) {
    for (var j = 0; j < videos.length; j++) start(videos[j]);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        start(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '300px 0px' }
  );

  for (var k = 0; k < videos.length; k++) observer.observe(videos[k]);
})();
